import AddPhoneStep from './addPhoneStep.view';

export default AddPhoneStep;
